import { render, staticRenderFns } from "./TemplateSynsPopover.vue?vue&type=template&id=153b0af2&"
import script from "./TemplateSynsPopover.vue?vue&type=script&lang=js&"
export * from "./TemplateSynsPopover.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSynsPopover.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports